import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '../../utils';
import { Button } from '../Button';
import { Icon } from '../Icon';
export function ExternalLinkButton({ disabled, children, href, errorText, }) {
    const isDisabled = !href || disabled;
    const button = (_jsx(ButtonStyled, { color: "primary", disabled: isDisabled, children: _jsxs(ButtonContentStyled, { children: [_jsx("div", { children: children }), _jsx(IconStyled, { variant: "arrow-right-up", fontSize: "medium", color: "inherit" })] }) }));
    return (_jsxs(_Fragment, { children: [isDisabled ? ( // if disabled, only show the button without a link
            button) : (_jsx(LinkStyled, { href: href ?? '', target: "_blank", rel: "noreferrer", children: button })), errorText && _jsx(ErrorTextStyled, { children: errorText })] }));
}
const ButtonStyled = styled(Button)(({ theme }) => ({
    // TODO: these blue colors are not in the theme palette
    backgroundColor: theme.palette.groupPrimary.dove,
    color: theme.palette.primary.dark,
    borderRadius: `${theme.spacing(1)}!important`,
    width: '100%',
    height: theme.spacing(8),
    transition: 'background-color 0.15s ease-in-out',
    '&:hover': {
        backgroundColor: theme.palette.groupPrimary.lightBlue,
    },
}));
const ButtonContentStyled = styled('div')(() => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
}));
const IconStyled = styled(Icon)(({ theme }) => ({
    marginLeft: theme.spacing(2),
}));
const LinkStyled = styled('a')(() => ({
    textDecoration: 'none',
}));
const ErrorTextStyled = styled('div')(({ theme }) => ({
    color: theme.palette.error.main,
    padding: theme.spacing(0.5, 1),
}));
